export default __webpack_public_path__ + "static/media/flag-saint-martin.cb2bd336.svg";